/**
 * Адрес фильтра заполнен целиком: у каждого сегмента есть значение.
 *
 * FILTER_URL товара без привязки к машине приходит в виде «marka-/», и ссылка
 * «подобрать» вела на /catalog/elektrika_farkopov/filter/marka-/ — адрес без
 * значения фильтра, который отвечает ошибкой (ТЗ 08.2026, п. 6.2).
 */
export function isCompleteFilterUrl(filterUrl?: string | null): boolean {
  if (typeof filterUrl !== "string") {
    return false;
  }

  const segments = filterUrl.split("/").filter(Boolean);
  if (segments.length === 0) {
    return false;
  }

  return segments.every((segment) => {
    const separatorAt = segment.indexOf("-");
    return separatorAt > 0 && segment.length > separatorAt + 1;
  });
}
